import React from "react";
import { Autocomplete } from "../atoms/Autocomplete";
import { Box } from "@mui/material";
import { Button } from "@mui/material";
import { Dialog } from "@mui/material";
import { SignatureTable } from "./SignatureTable";
import { TipTap } from "./TipTap";
import { zohoApi } from "../../zohoApi";
import CodeOutlinedIcon from "@mui/icons-material/CodeOutlined";
import orgVariableData from "../../config/orgVariable.json";

const similarObj = (obj1, obj2) => {
  for (let key in obj1) {
    if (JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key])) {
      return false;
    }
  }
  return true;
};

export const SignatureTab = ({ orgId, apiKey, dataCenterUrl, accessToken }) => {
  const [HTML, setHTML] = React.useState("");
  const [showHTML, setShowHTML] = React.useState(false);
  const [openConfirmationDialog, setOpenConfirmationDialog] =
    React.useState(false);
  const [dialogData, setDialogData] = React.useState(null);
  const [allowedEmailsInZoho, setAllowedEmailsInZoho] = React.useState([]);
  const [dataFromDB, setDataFromDB] = React.useState([]);
  const [rowstaLoading, setRowsLoading] = React.useState(false);
  const [reload, setReload] = React.useState(false);
  const [orgVariableLoading, setOrgVariableLoading] = React.useState(false);
  const [orgVariableInput, setOrgVariableInput] = React.useState({});
  const orgVariableInputRef_OriginalCopy = React.useRef({});

  const clearEditorRef = React.useRef();

  const disable = similarObj(
    orgVariableInput,
    orgVariableInputRef_OriginalCopy.current
  );

  React.useEffect(() => {
    const getDataFromZoho = async () => {
      setOrgVariableLoading(true);

      const { data: allowedEmails } =
        (await zohoApi.user.getAllowedEmails({
          accessToken,
          dataCenterUrl,
        })) || [];
      const tempAllowedEmails = allowedEmails?.map((email) => ({
        email,
      }));

      setAllowedEmailsInZoho(tempAllowedEmails);

      //------------getOrgVariable---------
      const { Success } = await window.ZOHO.CRM.API.getOrgVariable(
        `${process.env.REACT_APP_EXTENSION_IDENTIFIER}__Date_Time_Options`
      );
      const parsedResp = JSON.parse(Success?.Content || "{}");
      orgVariableInputRef_OriginalCopy.current = parsedResp;
      setOrgVariableInput(parsedResp);
      setOrgVariableLoading(false);
    };

    if (accessToken && dataCenterUrl) {
      getDataFromZoho();
    }
  }, [accessToken, dataCenterUrl]);

  React.useEffect(() => {
    const getDBData = async () => {
      setRowsLoading(true);
      const { data: signatureData } = await zohoApi.config.getConfigFromDB_2({
        moduleApiName: "userSignature",
        settingType: "",
        orgId,
        apiKey,
        dataCenterUrl,
      });
      setDataFromDB(signatureData);
      setRowsLoading(false);
    };

    if (apiKey && orgId && dataCenterUrl) {
      getDBData();
    }
  }, [apiKey, orgId, dataCenterUrl, reload]);

  let temp =
    dataFromDB?.map((obj) => {
      const setting_schema = obj?.setting_schema;
      const parsedSettingSchema = JSON.parse(setting_schema || "{}");
      return parsedSettingSchema?.users;
    }) || [];

  let emailsInDB = temp?.map((obj) => obj.email) || [];

  let emailObjectsNotInDB = allowedEmailsInZoho?.filter(
    (obj) => !emailsInDB?.includes(obj.email)
  );

  if (orgVariableLoading) {
    // !Object.keys(orgVariableInput)?.length ||
    // !Object.keys(allUsersInZoho)?.length
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
        }}
      >
        Feetching Data ...
      </Box>
    );
  }

  return (
    <>
      <Autocomplete
        options={orgVariableData?.Date_Format}
        optionLabel="format"
        label="Date format"
        disableClearable
        key="Date_Format"
        value={orgVariableInput?.Date_Format}
        onChange={(e, value) => {
          setOrgVariableInput((pre) => ({
            ...(pre || {}),
            Date_Format: value,
          }));
        }}
      />
      <Autocomplete
        options={orgVariableData?.Date_Time_Format}
        optionLabel="format"
        label="Date time format"
        disableClearable
        key="Date_Time_Format"
        value={orgVariableInput?.Date_Time_Format}
        onChange={(e, value) => {
          setOrgVariableInput((pre) => ({
            ...(pre || {}),
            Date_Time_Format: value,
          }));
        }}
      />
      {/* <Autocomplete
        options={orgVariableData?.Time_Zone}
        optionLabel="zone_name"
        label="Timezone"
        disableClearable
        key="Time_Zone"
        value={orgVariableInput?.Time_Zone}
        onChange={(e, value) => {
          setOrgVariableInput((pre) => ({
            ...(pre || {}),
            Time_Zone: value,
          }));
        }}
      /> */}

      <Button
        variant="contained"
        sx={{
          textTransform: "capitalize",
          display: "block",
          width: "100%",
          mb: ".6em",
        }}
        disableRipple
        onClick={async () => {
          const dataCenterData = {
            apiname: `${process.env.REACT_APP_EXTENSION_IDENTIFIER}__Date_Time_Options`,
            value: orgVariableInput,
          };
          await window.ZOHO.CRM.CONNECTOR.invokeAPI("crm.set", dataCenterData);
          ///----------------------
          const { Success } = await window.ZOHO.CRM.API.getOrgVariable(
            `${process.env.REACT_APP_EXTENSION_IDENTIFIER}__Date_Time_Options`
          );
          const parsedResp = JSON.parse(Success?.Content || "{}");
          orgVariableInputRef_OriginalCopy.current = parsedResp;

          setOrgVariableInput(parsedResp);
        }}
        disabled={Object.keys(orgVariableInput)?.length === 0 || disable}
      >
        Save ORG Variables
      </Button>

      <Button
        sx={{
          textTransform: "capitalize",
          mb: ".6em",
        }}
        onClick={() => {
          setDialogData(null);
          setOpenConfirmationDialog(true);
          setHTML("");
          setShowHTML(false);
        }}
        variant="contained"
        disableRipple
      >
        Users
      </Button>
      <Box sx={{ overflowY: "auto", height: "22rem" }}>
        <SignatureTable
          rows={dataFromDB}
          setDataFromDB={setDataFromDB}
          dialogData={dialogData}
          setDialogData={setDialogData}
          rowstaLoading={rowstaLoading}
          orgId={orgId}
          apiKey={apiKey}
          dataCenterUrl={dataCenterUrl}
          setReload={setReload}
        />
      </Box>
      <Dialog
        open={openConfirmationDialog}
        onClose={() => {
          setOpenConfirmationDialog(false);
        }}
        sx={{
          "& .MuiDialog-paper": {
            minWidth: "600px",
            minHeight: "400px",
            position: "relative",
          },
        }}
      >
        <Box
          sx={{
            p: "1rem",
            position: "absolute",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            gap: ".5rem",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: "1rem",
            }}
          >
            <Autocomplete
              options={emailObjectsNotInDB}
              optionLabel="email"
              // options={usersNotInDB}
              // optionLabel="full_name"
              //-----------
              // options={[
              //   ...(usersNotInDB || []),
              //   ...(allowedEmailsWithoutUser?.map((email) => ({
              //     id: email,
              //     full_name: email,
              //     email,
              //   })) || []),
              // ]}

              label="User list"
              onChange={(e, value, reason) => {
                if (reason === "clear") {
                  setDialogData({
                    object: null,
                    title: undefined,
                    content: undefined,
                    buttonText: "Save",
                  });
                  clearEditorRef.current();
                  setHTML("");
                  return;
                }
                setDialogData({
                  object: value,
                  title: undefined,
                  content: undefined,
                  buttonText: "Save",
                });
              }}
              sx={{ flexGrow: 1, mb: 0 }}
              variant="outlined"
            />
            <Button
              variant="outlined"
              sx={{ textTransform: "capitalize" }}
              disableRipple
              startIcon={<CodeOutlinedIcon />}
              onClick={() => {
                setShowHTML((pre) => !pre);
              }}
            >
              {showHTML ? "Go to Richtext" : "HTML Signature"}
            </Button>
          </Box>
          <Box
            sx={{
              border: 1,
              borderRadius: "4px",
              flexGrow: 1,
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {showHTML ? (
              <>
                {HTML === "" ? (
                  <Box
                    component="textarea"
                    disabled={!dialogData?.object}
                    placeholder="Only paste HTML code here..."
                    id="editor"
                    contenteditable="true"
                    sx={{ height: "100%", maxWidth: "100%", p: ".5em" }}
                    onChange={(e) => {
                      setHTML(e.target.value);
                      setDialogData((pre) => {
                        const { object, ...rest } = pre;
                        return {
                          ...(rest || {}),
                          object: {
                            ...(object || {}),
                            signature: e.target.value,
                          },
                        };
                      });
                    }}
                  />
                ) : (
                  <Box
                    id="preview"
                    sx={{ height: "100%", maxWidth: "100%", p: ".5em" }}
                    dangerouslySetInnerHTML={{ __html: HTML }}
                  />
                )}
              </>
            ) : (
              <TipTap
                key={dialogData?.object?.id}
                content={dialogData?.object?.signature}
                setEmailContent={(signature) => {
                  setDialogData((pre) => {
                    const { object, ...rest } = pre || {};
                    return {
                      ...(rest || {}),
                      object: { ...(object || {}), signature },
                    };
                  });
                }}
                ref={clearEditorRef}
                fieldNameApis={[]}
                signatureComp={true}
                // editable={!!dialogData?.object}
              />
            )}
          </Box>
          <Box
            sx={{ display: "flex", gap: ".5rem", justifyContent: "flex-end" }}
          >
            <Button
              variant="outlined"
              sx={{
                width: "fit-content",
                textTransform: "capitalize",
              }}
              onClick={() => {
                setDialogData(null);
                setOpenConfirmationDialog(false);
                setHTML("");
                setShowHTML(false);
              }}
            >
              Cancel
            </Button>
            <Button
              disabled={!dialogData?.object}
              onClick={async () => {
                const dbUpsertResp = await zohoApi.config.upsertConfigToDB({
                  orgId,
                  apiKey,
                  dataCenterUrl,
                  moduleApiName: "userSignature",
                  settingId: "",
                  settingSchema: { users: dialogData?.object },
                  settingType: undefined,
                });
                // setSavedUserIds((pre) => {
                //   const newSelectedIds = new Set(pre);
                //   newSelectedIds.delete(dialogData?.object?.id);
                //   return newSelectedIds;
                // });
                setReload((pre) => !pre);

                setOpenConfirmationDialog(false);
              }}
              variant="contained"
              sx={{
                width: "fit-content",
                textTransform: "capitalize",
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Dialog>
    </>
  );
};
